import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import textMessageBubbleChat from 'src/examples/BubbleChat/textMessage';
import fileMessageBubbleChat from 'src/examples/BubbleChat/fileMessage';
import typingMessageBubbleChat from 'src/examples/BubbleChat/typingMessage';
import senderMessageBubbleChat from 'src/examples/BubbleChat/senderMessage';
import reviserMessageBubbleChat from 'src/examples/BubbleChat/reviserMessage';
import systemMessageBubbleChat from 'src/examples/BubbleChat/systemMessage';
import imageMessageBubbleChat from 'src/examples/BubbleChat/imageMessage';
import * as React from 'react';
export default {
  graphql,
  ComponentApi,
  CodeView,
  textMessageBubbleChat,
  fileMessageBubbleChat,
  typingMessageBubbleChat,
  senderMessageBubbleChat,
  reviserMessageBubbleChat,
  systemMessageBubbleChat,
  imageMessageBubbleChat,
  React
};